import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal, Row } from 'react-bootstrap';

import './css/CancelModal.css';

class CancelModal extends Component {
  constructor(props) {
    super();
  }

  render() {
    return (
      <Modal show={this.props.show} className="inmodal">
        <Modal.Body>
          <Row className="warningDescriptionCancel">
            <h2>Palataanko etusivulle?</h2>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className="pull-right">
            <Button bsStyle="danger" bsSize="large" onClick={this.props.handleCancel}>Kyllä</Button>
            <Button bsSize="large" onClick={this.props.disableCancelConfirm}>Ei</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    );
  }
}

CancelModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  disableCancelConfirm: PropTypes.func.isRequired
};

export default CancelModal;



// WEBPACK FOOTER //
// ./src/components/CancelModal.jsx